export const addHexPrefix = str => str.slice(0, 2) === '0x' ? str : `0x${str}`;
